document.addEventListener('contextmenu', function(e) {
  //  e.preventDefault()
})

document.onkeydown = function(e) {
  if (e.keyCode == 123) {
    return true
  }
  if (e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
    return true
  }
  if (e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
    return true
  }
  if (e.metaKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
    return true
  }
  if (e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
    return true
  }
  if (e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
    return true
  }
  if (e.metaKey && e.keyCode == 'C'.charCodeAt(0)) {
    console.log('er')
    return true
  }
  if (e.metaKey && e.keyCode == 'V'.charCodeAt(0)) {
    return true
  }
  if (e.metaKey && e.keyCode == 'X'.charCodeAt(0)) {
    return true
  }
  if (e.metaKey && e.keyCode == 'Z'.charCodeAt(0)) {
    return true
  }
  if (e.metaKey && e.keyCode == 'A'.charCodeAt(0)) {
    return true
  }
}
